import asyncComponent from '../../app/AsyncComponent/AsyncComponent';
export {default as page} from './page';

export default asyncComponent(() => import('./Page404'));
